import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { StatsConsoleWrapper } from '@components/StatsConsoleWrapper';
import TestWidgetsView from './components/StatsConsole/TestingStatsConsole/TestWidgetsView';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState } from 'react';
import TestWidgetsExamplesList from './components/StatsConsole/TestingStatsConsole/TestWidgetsExamplesList';
import { ThemeProvider } from './stores/ThemeContext';
import { ColorProvider } from './stores/ColorContext';
import { NotFound } from './components/common/NotFoundPage';
import { IState, initialStateContext, StateContext } from './state/stateContext';
import TimelinePlayer from '@components/TimlinePlayer/TimelinePlayer';
import VisualistaionPlayer from '@components/VisualistaionPlayer/VisualistaionPlayer';
import Test from '@components/StatsConsole/TestingStatsConsole/Test';
import TestColorWidget from '@components/StatsConsole/TestingStatsConsole/TestColorWidget';
import ErrorBoundary from '@components/common/ErrorBoundary';
import RefreshIconAndText from '@components/common/RefreshIconAndText';
import { TranslationProvider } from './translation/TranslationContext';
import { DataOrchestratorProvider } from './stores/DataOrchestrator';

const queryClient = new QueryClient();

const App = () => {
  const isInIframe = window.self !== window.top;
  const [stContext, setStContext] = useState<IState>(initialStateContext)

  return (
    <ErrorBoundary>
      <StateContext.Provider value={{ stContext, setStContext }}>
        <ThemeProvider>
          <DataOrchestratorProvider>
            <ColorProvider>
              <TranslationProvider>
                <QueryClientProvider client={queryClient}>
                {!isInIframe && <ReactQueryDevtools initialIsOpen={false} />}
                <Router>
                  <Routes>
                    <Route path="/" element={<TestWidgetsExamplesList />} /> 
                    <Route path="/generator" element={<TestWidgetsView />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/StatsConsole/:locale/" element={<StatsConsoleWrapper item={"StatsConsole"}/>} />
                    <Route path="/StatsConsole/:locale/:state" element={<StatsConsoleWrapper item={"StatsConsole"}/>} />
                    <Route path="/TimelinePlayer/" element={<TimelinePlayer />} />
                    <Route path="/TimelinePlayer/:locale/" element={<TimelinePlayer />} />
                    <Route path="/TimelinePlayer/:locale/:state" element={<TimelinePlayer />} />
                    <Route path="/VisualistaionPlayer/" element={<VisualistaionPlayer />} />
                    <Route path="/VisualistaionPlayer/:locale/" element={<VisualistaionPlayer />} />
                    <Route path="/VisualistaionPlayer/:locale/:state" element={<VisualistaionPlayer />} />
                    <Route path="/test" element={<Test />} />
                    <Route path="/test-color" element={<TestColorWidget />} />
                  </Routes>
                </Router>
                </QueryClientProvider>
              </TranslationProvider>
            </ColorProvider>
          </DataOrchestratorProvider>
        </ThemeProvider>
      </StateContext.Provider>
    </ErrorBoundary>
  );
};

export default App;